/**
 * WordPress components that create the necessary UI elements for the block
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-components/
 */
//import { TextControl } from '@wordpress/components';
/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';
/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps } from '@wordpress/block-editor';
/**
 * Icons
 */
import icons from './icons.js';

import apiFetch from '@wordpress/api-fetch';

import { useState } from '@wordpress/element';

import MoMoAutoContentGenerator from './momo-auto-content-generator.js';
/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @param {Object}   props               Properties passed to the function.
 * @param {Object}   props.attributes    Available block attributes.
 * @param {Function} props.setAttributes Function that updates individual attributes.
 *
 * @return {WPElement} Element to render.
 */
const {
    Button,
    Notice,
    ToggleControl,
    Placeholder,
    PanelBody,
    PanelRow,
    Heading,
    SelectControl,
    TextControl,
    Spinner,
    /* ServerSideRender, */
} = wp.components;
import {
    InspectorControls,
    RichText
} from '@wordpress/block-editor';
const { Fragment } = wp.element;
export default function Edit( { attributes, setAttributes } ) {
    const blockProps = useBlockProps();
    const {
        language,
        title,
        noOfPara,
        headingsYesNo,
        headingsWrapper,
        writingStyle,
        introductionYesNo,
        conclusionYesNo,
        imageYesNo,
        hyperlinkYesNo,
        hyperlinkText,
        anchorLink,
        generatedContent,
        isGenerating,
        contentGenerated,
        generatedResult,
        cannotGenerateContent,
        errorMessage
    } = attributes;
    /* const {
        isGenerating,
    } = useState(); */
    const languagearr = Object.entries(momoacg_block_admin.language);
    const writingS = Object.entries(momoacg_block_admin.writing_style);
   /*  setAttributes({cannotGenerateContent : false});
    setAttributes({errorMessage : ''}); */
    let languages = [];
    let writings = [];
    let ajaxMessage,ajaxStatus;
    for (const lang of languagearr) {
        languages.push({
            label : lang[1],
            value : lang[0]
        });
    }
    for (const ws of writingS) {
        writings.push({
            label : ws[1],
            value : ws[0]
        });
    }
    let noofpara = [];
    for ( let i = 1; i<=10; i++) {
        noofpara.push({
            label: i,
            value: i
        });
    }
    const handleGenerateContent = button => {
        setAttributes( {isGenerating: true} );
        let options = {};
        options.language = language;
        options.title = title;
        options.noOfPara = noOfPara;
        options.headingsYesNo = headingsYesNo;
        options.headingsWrapper = headingsWrapper;
        options.writingStyle = writingStyle;
        options.introductionYesNo = introductionYesNo;
        options.conclusionYesNo = conclusionYesNo;
        options.imageYesNo = imageYesNo;
        options.hyperlinkYesNo = hyperlinkYesNo;
        options.hyperlinkText = hyperlinkText;
        options.anchorLink = anchorLink;console.log(options);
        apiFetch( {
            path: "/momoacg/v1/openai-contents/",
            method: "POST",
            data: options,
        } ).then( ( res ) => {
            ajaxStatus = res.status;
            ajaxMessage = res.msg;console.log(res);
            if ( 'good' === ajaxStatus ) {
                let content = res.content;
                setAttributes({generatedContent: content});
                setAttributes({contentGenerated: true});
                setAttributes( {cannotGenerateContent : false} );
            } else {
                setAttributes({errorMessage : ajaxMessage});
                setAttributes( {cannotGenerateContent : true} );
            }
            setAttributes({ isGenerating: false});
        } );
    };
    let oldContent = false;
    if ( true === contentGenerated ) {
        oldContent = true;
    } else {
        oldContent = false;
    }
    return (
        <div { ...blockProps }>
            <Fragment>
                <InspectorControls>
                    <PanelBody
                        icon={icons.content}
                        label={ __('Auto Content Generator', 'momoacg') }
                        instructions= { __( 'Select appropriate settings and click generate content button.', 'momoacg' ) }
                    >
                        <SelectControl
                            label={ __('Select Language', 'momoacg') }
                            value={ language }
                            default={ 'english' }
                            options={
                                languages
                            }
                            onChange={ ( val ) => {
                                setAttributes( {language: val} );
                            } }
                        />
                        <TextControl
                        label={ __('Title', 'momoacg') }
                            placeholder={ __('Artificial Inteligence', 'momoacg') }
                            onChange={ ( val ) => setAttributes( { title: val } ) }
                            value={title}
                        />
                        <SelectControl
                            label={ __('Number of Paragraphs', 'momoacg') }
                            default={ '1' }
                            value= { noOfPara }
                            options={
                                noofpara
                            }
                            onChange={ ( val ) => {
                                setAttributes( {noOfPara: val} );
                            } }
                        />
                        <ToggleControl
                            label={ __( 'Add headings to paragraph', 'momoacg' ) }
                            checked={ headingsYesNo }
                            onChange={ ( val ) => {
                                setAttributes( {
                                    headingsYesNo: val,
                                } );
                                
                            } }
                        />
                        { true === headingsYesNo &&
                            <SelectControl
                            label={ __('Wrap heading with', 'momoacg') }
                            value={ 'h1' }
                            options={ [
                                { label: 'H1', value: 'h1' },
                                { label: 'H2', value: 'h2' },
                                { label: 'H3', value: 'h3' },
                                { label: 'H4', value: 'h4' },
                                { label: 'H5', value: 'h5' },
                                { label: 'H6', value: 'h6' },
                            ] }
                            onChange={ ( val ) => {
                                setAttributes( {headingsWrapper: val} );
                            } }
                        />
                        }
                        <SelectControl
                            label={ __('Writing Styles', 'momoacg') }
                            value={ 'informative' }
                            options={
                                writings
                            }
                            onChange={ ( val ) => {
                                setAttributes( {writingStyle: val} );
                            } }
                        />
                        <ToggleControl
                            label={ __( 'Add Introduction', 'momoacg' ) }
                            checked={ introductionYesNo }
                            onChange={ ( val ) => {
                                setAttributes( {
                                    introductionYesNo: val,
                                } );
                                
                            } }
                        />
                        <ToggleControl
                            label={ __( 'Add Conclusion', 'momoacg' ) }
                            checked={ conclusionYesNo }
                            onChange={ ( val ) => {
                                setAttributes( {
                                    conclusionYesNo: val,
                                } );
                                
                            } }
                        />
                        <ToggleControl
                            label={ __( 'Generate Image', 'momoacg' ) }
                            checked={ imageYesNo }
                            onChange={ ( val ) => {
                                setAttributes( {
                                    imageYesNo: val,
                                } );
                                
                            } }
                        />
                        <ToggleControl
                            label={ __( 'Add Hyperlink to selected text', 'momoacg' ) }
                            checked={ hyperlinkYesNo }
                            onChange={ ( val ) => {
                                setAttributes( {
                                    hyperlinkYesNo: val,
                                } );
                                
                            } }
                        />
                        { true === hyperlinkYesNo &&
                        <div>
                            <TextControl
                                label={ __('Search Text', 'momoacg') }
                                placeholder={ __('Artificial Inteligence', 'momoacg') }
                                onChange={ ( val ) => setAttributes( { hyperlinkText: val } ) }
                            />
                            <TextControl
                                label={ __('Anchor Text', 'momoacg') }
                                placeholder={ __('https://', 'momoacg') }
                                onChange={ ( val ) => setAttributes( { anchorLink: val } ) }
                                value={anchorLink}
                            />
                        </div>
                        }
                        <Button
                            variant="primary"
                            label={ __( 'Generate Content', 'momoacg' ) }
                            onClick={ handleGenerateContent }
                            disabled={isGenerating}
                            >
                                { true === isGenerating ? (
                                <>
                                    <Spinner/>
                                    { __( 'Generating Content', 'momoacg') }
                                </>
                            ) : 
                                ( true === oldContent ? (
                                    __( 'Regenerate Content', 'momoacg' )
                                    ) : __( 'Generate Content', 'momoacg' )
                                )
                            }
                        </Button>
                    </PanelBody>
                </InspectorControls>
            </Fragment>
            {/* <MoMoAutoContentGenerator
            options={attributes}
            /> */}
            { false === oldContent &&
                    <Placeholder
                    icon={icons.content}
                    label={ __('Auto Content Generator', 'momoacg') }
                    instructions= { momoacg_block_admin.block_help }
                    isColumnLayout
                    >
                    </Placeholder>
                }
                { true === oldContent &&
                    <RichText
                    value={generatedContent}
                    /* allowedFormats={ [ 'core/bold', 'core/italic' ] } */
                    onChange={ ( content ) => setAttributes( { generatedContent: content } ) }
                    disabled={ isGenerating }
                    />
                }
        </div>
    );
}
